// PoweredByAkuto.jsx
// 店の画面の下に小さく添える「powered by AKUTO」(AKUTO ブランド: 店のロゴが主役、AKUTO は前に出ない)。
import React from "react";
import { AkutoWordmark } from "./AkutoLogo";

export default function PoweredByAkuto({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-1.5 py-8 text-[10px] font-bold text-gray-400 ${className}`}>
      powered by
      <AkutoWordmark height={9} className="text-gray-400" />
    </div>
  );
}
